import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import { ErrorBox } from './Shared';
import BsiIcon, { buttonIcon } from './BsiIcon';
import { api, t, errorText } from '../helpers';
export default class ChangePasswordModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.fields = {
      current_password: '',
      new_password: '',
      new_password_confirmation: ''
    };
  }
  className() {
    return 'BsiChangePasswordModal Modal--small';
  }
  title() {
    return m("span", {
      className: "BsiAuthHeading"
    }, m("span", {
      className: "BsiAuthEmblem"
    }, m(BsiIcon, {
      name: "lock-key"
    })), m("span", null, t('profile.change_password')));
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("form", {
      onsubmit: e => this.submit(e)
    }, m(ErrorBox, {
      error: this.error
    }), Object.keys(this.fields).map(field => m("div", {
      className: "Form-group",
      key: field
    }, m("label", {
      htmlFor: 'bsi-' + field
    }, t('profile.' + field)), m("input", {
      className: "FormControl",
      type: "password",
      id: 'bsi-' + field,
      name: field,
      required: true,
      autocomplete: field === 'current_password' ? 'current-password' : 'new-password',
      minlength: field === 'current_password' ? undefined : 8,
      value: this.fields[field],
      disabled: this.loading,
      oninput: e => this.fields[field] = e.target.value
    }))), m("p", {
      className: "helpText"
    }, t('profile.password_help')), m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      icon: buttonIcon('lock-key'),
      loading: this.loading,
      disabled: this.loading
    }, t('profile.password_save'))));
  }
  async submit(event) {
    event.preventDefault();
    if (this.loading) return;
    this.error = null;
    if (this.fields.new_password !== this.fields.new_password_confirmation) {
      this.error = t('errors.password_mismatch');
      return;
    }
    this.loading = true;
    try {
      await api('/account/password', {
        method: 'POST',
        body: {
          data: {
            attributes: {
              ...this.fields
            }
          }
        }
      });
      this.clearFields();
      this.hide();
      app.alerts.show({
        type: 'success'
      }, t('profile.password_changed'));
    } catch (error) {
      this.error = errorText(error);
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  clearFields() {
    for (const field of Object.keys(this.fields)) this.fields[field] = '';
  }
  onremove(vnode) {
    super.onremove(vnode);
    this.clearFields();
  }
}
flarum.reg.add('bsi-orders', 'forum/components/ChangePasswordModal', ChangePasswordModal);